//@ts-check
import superagent from 'superagent';
import store from '../../store';
import ACTIONS from '../../store/actions';
/**
 * @type {import('./types').requestType}
 */

export default (function (options) {
  return store.dispatch({
    type: ACTIONS.REQUEST_METHOD,
    request: options
  }).then(function (actionResponse) {
    var supportedParsers = Object.keys(superagent.parse);
    if (supportedParsers.indexOf(actionResponse.type) > -1) return actionResponse.body;
    if (!actionResponse.body) return actionResponse.text;
    return actionResponse.body;
  });
});